/**
 * Label provider constants shared across ShipStation applications.
 */

/**
 * A label provider is a specific account type or integration (e.g. UPS Wallet vs UPS BYOA) — not the carrier itself.
 * labelProviderId is not always equal to carrierId — use {@link Carriers} when the data only has a carrierId field.
 */
export const LabelProviders = {
  DhlExpressWallet: '38',
  DummyCarrier: '1000',
  FedExWallet: '194',
  /** Carrier insurance is not supported for this provider. */
  FedExUkWallet: '4312',
  UspsWallet: '2',
  UpsWallet: '103',
  UpsInvoiced: '4790',
} as const;

export type LabelProviderId = (typeof LabelProviders)[keyof typeof LabelProviders];
